import React, { useState } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const UpdateSchedulerInfo = () => {
  const { id, recordId } = useParams();
  const navigate = useNavigate();

  // State to hold form data
  const [formData, setFormData] = useState({
    name: "",
    remark: "",
    active: true,
    starttime: "",
    endtime: ""
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  const [fetchLoading, setFetchLoading] = useState(true);
  const [timeError, setTimeError] = useState("");

  // Fetch schedule info data on component mount
  React.useEffect(() => {
    fetchRecordData();
  }, []);

  const fetchRecordData = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      return;
    }

    setFetchLoading(true);
    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/CatalogSchedulerInfoOperation/SubUser/Search',
        {
          id: parseInt(recordId),
          schedulerid: parseInt(id),
        },
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );

      if (response.data && response.data.data && response.data.data.length > 0) {
        const record = response.data.data.find(r => r.id === parseInt(recordId));
        if (record) {
          setFormData({
            name: record.schedulername || "",
            remark: record.remark || "",
            active: record.active !== undefined ? record.active : true,
            starttime: record.starttime || "",
            endtime: record.endtime || ""
          });
        } else {
          setMessage("Record not found");
        }
      } else {
        setMessage("Record not found");
      }
    } catch (error) {
      console.error("Error fetching record data:", error);
      setMessage("Failed to fetch record data");
    } finally {
      setFetchLoading(false);
    }
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "starttime") {
      // Clear endtime when starttime changes
      setFormData(prev => ({
        ...prev,
        [name]: value,
        endtime: ""
      }));
      setTimeError("");
    } else if (name === "endtime") {
      // Validate endtime against starttime
      if (formData.starttime && value) {
        if (value <= formData.starttime) {
          setTimeError("End Time must be greater than Start Time");
        } else {
          setTimeError("");
        }
      }
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    if (!formData.starttime || !formData.endtime) {
      setMessage("Please select both start and end times");
      return;
    }

    if (formData.endtime <= formData.starttime) {
      setTimeError("End Time must be greater than Start Time");
      return;
    }

    const dataToSend = {
      id: parseInt(recordId),
      active: formData.active,
      starttime: formData.starttime,
      endtime: formData.endtime
    };

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/CatalogSchedulerInfoOperation/SubUser/Update',
        dataToSend,
        {
          headers: {
            "X-Authorization": token,
            "UserId": userid,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.isresponse) {
        setMessage("Scheduler info updated successfully!");
        setTimeout(() => {
          navigate(`/showschedule/${id}/Schedule`);
        }, 3000);
      } else {
        setMessage(response.data?.errormsg || "Failed to update scheduler info");
      }
    } catch (error) {
      console.error("Error updating schedule info:", error);
      setMessage(error.response?.data?.message || "Failed to update scheduler info");
    }
  };

  if (fetchLoading) {
    return (
      <>
        <Menu />
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content">
              <div className="container-fluid">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Update Scheduler Info</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter name"
                                name="name"
                                required
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>

                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Start Time</label>
                              <input
                                type="time"
                                className="form-control"
                                value={formData.starttime}
                                onChange={handleChange}
                                name="starttime"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>End Time</label>
                              <input
                                type="time"
                                className="form-control"
                                value={formData.endtime}
                                onChange={handleChange}
                                name="endtime"
                                required
                                min={formData.starttime || ""}
                                disabled={!formData.starttime}
                              />
                              {timeError && (
                                <div className="text-danger mt-1">
                                  <small>{timeError}</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>


                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Update
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Scheduler info updated successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to update scheduler info." ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default UpdateSchedulerInfo;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
